export const NOTIFICATION_TYPES_WITH_AVATARS = [
  'shift_swap_created',
  'shift_application_submitted',
  'shift_swap_accepted',
  'clock_in',
  'clock_in_missing',
  'clock_out_missing',
  'clock_out',
  'account_confirmed',
  'leave_submitted',
  'user_birthday',
  'warn_clock_in',
];

export const USERS_LIST_GROUPS_COLLAPSE_THRESHOLD = 3;
export const EMPLOYEE_HEADER_HEIGHT = 76;
export const ACTION_BAR_HEIGHT = 68;
export const TIMEZONE_BANNER_HEIGHT = 60;
export const FILTERS_BAR_HEIGHT = 56;

export const MONTH_NAMES = {
  monthsAbbr: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
};
